import { useSearchParams } from 'react-router-dom';

const useUrlSearchParams = (): URLSearchParams => {
  const [searchParams] = useSearchParams();

  const urlSearchParams = new URLSearchParams();
  searchParams.forEach((value, key) => {
    urlSearchParams.append(key.toLowerCase(), value);
  });

  return urlSearchParams;
};

export default useUrlSearchParams;
